import requireLoggedInUser from '@client/containers/requireLoggedInUser';
import { SubscriptionSearchPage } from '@client/modules/subscription-search/SubscriptionSearchPage/component';
import type React from 'react';

export const SubscriptionSearchPageContainer: React.ComponentClass = requireLoggedInUser(SubscriptionSearchPage);
